import React from 'react';
import './styles.css';





export const AulasAventurerosTituloEncabezado = () => {


  return (
    <>


        <div className='AulasAventurerosTituloEncabezado-Principal-Container'>

                <div className='AulasAventurerosTituloEncabezado-subContainer'>

                        <div className='AulasAventurerosTituloEncabezado-titulo'/>

                        <div className='AulasAventurerosTituloEncabezado-imagen'/>
                        
                </div>
        </div>

        
    </>
  )
}
